import { useContext } from "react";

import { MixpanelContext } from "./MixpanelContext";

export const useMixpanelContext = () => useContext(MixpanelContext);
